import React from "react"

class BigErrorIcon extends React.Component<{}> {
    render() {
        return (
            <div
                style={{
                    margin: "0 auto",
                    width: "160px",
                    height: "130px",
                    padding: "1rem",
                    position: "relative",
                    left: "-7px",
                    backgroundImage: "url('/assets/general_error_icon.svg')",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                    marginBottom: "1.25rem",
                }}
            />
        )
    }
}

export default BigErrorIcon
